import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Tent } from "lucide-react";
import { toast } from "sonner";
import { KpiCards, SectionCards, QuickActions, AbsenceAlerts, UpcomingBirthdays, SectionMoves } from "@/components/DashboardWidgets";
import MyRequests from "@/components/MyRequests";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/stats/dashboard");
      setStats(data);
    } catch (err) {
      toast.error("Could not load dashboard stats");
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-8" data-testid="dashboard-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Lough Scouts 5th Cork</div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Outfit" }}>Group Dashboard</h1>
          <p className="text-muted-foreground text-sm mt-1">A snapshot of the group's people, attendance and finances.</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Tent className="w-4 h-4" /> Weekly meetings · Thursday evenings
        </div>
      </div>
      <KpiCards stats={stats} />
      <SectionCards counts={stats?.section_counts} />
      <QuickActions overdueCount={stats?.overdue_count ?? 0} />
      <UpcomingBirthdays birthdays={stats?.upcoming_birthdays ?? []} />
      <AbsenceAlerts alerts={stats?.absence_alerts ?? []} threshold={stats?.absence_threshold ?? 3} />
      <SectionMoves moves={stats?.section_moves ?? []} onMoved={load} />
      <MyRequests />
    </div>
  );
}
